<div class="audit-request-table">
    <h3>
        Audit Request
    </h3>

    <pageable-table
        [items]="auditRequests"
        [paging]="paging"
        [columns]="getColumnMap()"
        (refreshData)="getAuditRequests($event)">
    </pageable-table>
</div>